import React from "react";
import styled from "styled-components";

import { Button } from "@/components/Form";
import { HEXtoRGBA } from "@/styles/helper";
import { moveUpAndFadeIn } from "@/styles/Mixins";
import Markdown from "@/utils/markdown";

export type IntroProps = {
  label: string;
  text: string;
  onButtonClick?: () => void;
  hideButton?: boolean;
  hasBackgroundImage?: boolean;
};

export class Intro extends React.Component<IntroProps, {}> {
  public render(): JSX.Element {
    const { label, text, hideButton, hasBackgroundImage } = this.props;

    return (
      <React.Fragment>
        <IntroBox hasBackgroundImage={hasBackgroundImage}>
          <IntroBoxText dangerouslySetInnerHTML={{ __html: Markdown(text) }} />
          {!hideButton && (
            <IntroBoxButton>
              <Button data-qa="intro:btn" onClick={this.props.onButtonClick}>
                {label}
              </Button>
            </IntroBoxButton>
          )}
        </IntroBox>
      </React.Fragment>
    );
  }
}

const IntroBox = styled.div<{ hasBackgroundImage?: boolean }>`
    flex: none;
    width: 96%;
    color: ${(props: any) => props.theme.colors.black};
    text-align: center;
    ${(props: any) =>
      (props.theme.thesis.hasIntroBackground || props.hasBackgroundImage) &&
      `background-color: ${
        props.theme.thesis.hasTransparency
          ? HEXtoRGBA(props.theme.colors.white, 0.9)
          : props.theme.colors.white
      };
        box-shadow: ${props.theme.shadows.s400};`}
    padding: ${(props: any) => props.theme.spacing.desktop.s500}px;
    max-width: 500px;
    margin: ${(props: any) => props.theme.spacing.desktop.s500}px auto;
    border-radius: ${(props: any) => props.theme.borders.borderRadius};
    animation: ${moveUpAndFadeIn({ size: "30px" })} 250ms linear;
`;

const IntroBoxText = styled.div`
  font-size: ${(props: any) => props.theme.typography.h600};
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    font-size: ${(props: any) => props.theme.typography.h400};
  }
`;

const IntroBoxButton = styled.div`
  margin-top: ${(props: any) => props.theme.spacing.desktop.s500}px;
  text-align: center;
  min-width: 90%;
`;
